import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import LoadingOverlay from "components/ui/LoadingOverlay";
import LoginScreen from './pages/login-screen';

// Lazy-load heavy routes (reportes ships recharts/d3/jspdf/html2canvas).
// Login stays eager because it's the entry point.
const VisitFormRegistrationScreen = lazy(() => import('./pages/visit-form-registration-screen'));
const VisitRecordsViewerScreen = lazy(() => import('./pages/visit-records-viewer-screen'));
const ClientsDirectoryScreen = lazy(() => import('./pages/clients-directory-screen'));
const ReportesScreen = lazy(() => import('./pages/reportes-screen'));

const RouteFallback = () => <LoadingOverlay isVisible message="Cargando..." fullScreen />;

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <Suspense fallback={<RouteFallback />}>
          <RouterRoutes>
            <Route path="/" element={<LoginScreen />} />
            <Route path="/login" element={<LoginScreen />} />
            <Route path="/visit-form-registration-screen" element={<VisitFormRegistrationScreen />} />
            <Route path="/visit-records-viewer-screen" element={<VisitRecordsViewerScreen />} />
            <Route path="/clients-directory-screen" element={<ClientsDirectoryScreen />} />
            <Route path="/reportes-screen" element={<ReportesScreen />} />
            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
        </Suspense>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
